// General
import "./global-settings.scss";
import { useState, useEffect } from "react";
// Redux
import { useSelector, useDispatch } from "react-redux";
import {
  updateProfileBorderEnabled,
  updateProfileBorderImage,
} from "../../../../redux/store/profileBorderStore";
// Material UI
import { Button, IconButton, FormControlLabel, Switch } from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";

const GlobalSettings = () => {
  // General variables
  const [imageData, setImageData] = useState(null);

  // Redux variables
  const profileBorderEnabled = useSelector(
    (state) => state.profileBorder.profileBorderEnabled
  );
  const dispatch = useDispatch();

  // // Event Handlers | Button
  const onFilePicker = async (event) => {
    const file = event.target.files[0];

    if (file !== undefined) {
      try {
        const imageData = await readFile(file);
        setImageData((prevState) => ({
          ...prevState,
          image: imageData,
          file: file,
        }));
        dispatch(updateProfileBorderImage(imageData));
      } catch (error) {
        console.log(error);
      }
    }
  };

  // Event Handlers | MUI Switch
  const onShowProfileBorder = () => {
    dispatch(updateProfileBorderEnabled(!profileBorderEnabled));
  };

  // Utility Functions
  const readFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        resolve(event.target.result);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  };

  return (
    <div id="profile-border-global-settings-subcomponent">
      <div className="global-settings-label">Global Settings </div>

      <div className="profile-border-content">
        <div className="profile-border-preview-container">
          <div className="profile-border-preview-label-container">
            <IconButton
              className="profile-img-button"
              disableRipple
              component="label"
            >
              <input
                hidden
                accept="image/*"
                type="file"
                onChange={onFilePicker}
              />
              <UploadIcon />
            </IconButton>

            <div className="profile-border-preview-label">Preview</div>
          </div>

          <div className="profile-border-preview-image-container">
            <img className="profile-border-preview" src={imageData?.image} />
          </div>
        </div>

        <div className="profile-border-settings-container">
          <div>
            Note: profile photo is scaled down by 80% when there is a profile
            border
          </div>

          <FormControlLabel
            control={
              <Switch
                checked={profileBorderEnabled}
                onChange={onShowProfileBorder}
              />
            }
            label="Enable"
          />
        </div>
      </div>
    </div>
  );
};

export default GlobalSettings;
